import { useCallback, useEffect, useState } from 'react';

export const useCircularBufferView = (collection, pageSize) => {
  const [page, setPage] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (collection.length === 0) {
      setPage([]);
      return;
    }

    const newPage = [];
    let index = currentIndex % collection.length;
    let count = 0;
    while (count < pageSize && count < collection.length) {
      newPage.push(collection[index]);
      index = (index + 1) % collection.length;
      count += 1;
    }
    setPage(newPage);
  }, [collection, currentIndex, pageSize]);

  const canMoveNext = collection.length > pageSize;

  const moveNext = useCallback(() => {
    setCurrentIndex((currentIndex + pageSize) % collection.length);
  }, [currentIndex, collection.length, pageSize]);

  return [page, canMoveNext, moveNext];
};
